import bg from '../assets/bg.png';
import chef from '../assets/chef.jpeg';
import gallery01 from '../assets/1.jpg';
import gallery02 from '../assets/3.JPG';
import gallery03 from '../assets/2.JPG';
import gallery04 from '../assets/4.JPG';
import gallery05 from '../assets/5.JPG';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/location.jpg';
import laurels from '../assets/laurels.jpeg';
import award01 from '../assets/award01.png';
import award02 from '../assets/award02.png';
import award03 from '../assets/award03.png';
import award05 from '../assets/award05.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';

export default {
  bg,
  chef,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  knife,
  logo,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  sign,
  quote,
  gericht,
};
